import React from "react";
import { connect } from "react-redux";

import { popModal, removeModal } from "../../../store/actions";
import ModalViewController from "./ModalViewController";
import Modal from "colbi_web_ui/lib/components/Modal/Modal";
import styles from "./ModalController.module.sass";

const ModalController = ({ modals, pop, remove, pushNotification }) => {
    return modals && modals.length
        ? modals.map((modal, index) => {
              const {
                  id,
                  title,
                  transition,
                  view,
                  modalType,
                  customHeaderButton,
                  customHeaderButtonNames,
              } = modal;
              let windowClassName = styles[transition];
              if (modals.length > 1) {
                  if (
                      modals.length > 1 &&
                      index === modals.length - 2 &&
                      modals[modals.length - 1].$$state === "leave"
                  ) {
                      windowClassName = styles["push-front"];
                  } else if (index < modals.length - 1) {
                      windowClassName = styles["push-back"];
                  }
              }
              const modalTypeByCss = modalConfigs(modalType);
              return (
                  <Modal key={id}>
                      <div className={styles["backdrop"]} />
                      <div
                          className={`${styles[`${modalTypeByCss}`]} ${windowClassName || ""} ${styles[view === "AuditNotesForm" ? "override-modal-height" : ""]}`}
                          data-form-id={id}
                          onAnimationEnd={(e) => {
                              if (e.animationName === styles["leave"]) {
                                  remove(e.target.dataset.formId);
                              }
                          }}
                      >
                          <ModalViewController
                              id={id}
                              title={title}
                              view={view}
                              modalType={modalType}
                              customHeaderButton={customHeaderButton}
                              customHeaderButtonNames={customHeaderButtonNames}
                          />
                      </div>
                  </Modal>
              );
          })
        : null;
};

function modalConfigs(modalType) {
    return `modal${modalType ? `-${modalType}` : ""}-window`;
}

export default connect(
    ({ modals }) => ({
        modals,
    }),
    {
        pop: popModal,
        remove: removeModal,
    },
)(ModalController);
